import React from 'react';
import classes from './style.module.css';
import { Switch } from '@material-ui/core';
import { useWatch } from 'react-hook-form';

const CheckboxSwitch = ({
    register,
    control,
    name,
    label
}) => {
    const value = useWatch({
        control,
        name,
    })
    console.log(value)
    return (
        <label
            htmlFor={name}
            className={classes.label}
        >
            <span className={classes.label__helper}>
                {label}
            </span>
            <Switch
                {...register(name)}
                id={name}
                color="primary"
                defaultChecked={value}
            />
        </label>
    )
}

export default CheckboxSwitch;